<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" lg="4" xl="3" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                    ref="districtCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="3" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="3">
        <BaseSelect :options="connectStatusSelect.options" :data="connectStatusSelect.data"
                    ref="connectStatusSelect"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="3">
        <BaseSelect :options="activeStatusSelect.options" :data="activeStatusSelect.data"
                    ref="activeStatusSelect"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="3">
        <BaseSelect :options="statusSelect.options" :data="statusSelect.data"
                    ref="statusSelect"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="3">
        <BaseInput
          :options="serialIdInput.options"
          :data="serialIdInput.data"
        />
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="3">
        <BaseInput
          :options="descriptionInput.options"
          :data="descriptionInput.data"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #serialId="{item}">
            <td>
              <span :key="item.serialId" v-c-tooltip:hover="item.serialId" class="description">{{
                  item.serialId
                }}</span>
            </td>
          </template>
          <template #volume="{item}">
            <td style="text-align: center;">
              <range-slider class="slider" min="0" max="100" step="5" v-model="item.volume"
                            @change="changeVolume(item.id, item.volume)">
              </range-slider>
              <span>{{ item.volume }}</span>
            </td>
          </template>
          <template #updateDate="{item}">
            <td>{{ $helper.formatDate(item.updateDate) }}</td>
          </template>
          <template #locationName="{item}">
            <td>{{ item.locationName ? item.locationName : 'Chưa được gán' }}</td>
          </template>
          <template #activeStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.activeStatus == 1">Hoạt động</span>
              <span class="badge badge-danger" v-if="item.activeStatus == 0">Không hoạt động</span>
            </td>
          </template>
          <template #connectStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
              <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
            </td>
          </template>
          <template #status="{item}">
            <td>
                <span v-if="item.status == 1" class="dot-custom dot-success">
                Đã duyệt
              <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Hủy duyệt'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_status', item.id, item.serialId, item.status)"/>
              </span>
              <span v-else class="dot-custom dot-danger">
                Chưa duyệt
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Duyệt'" v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_status', item.id, item.serialId, item.status)"/>
              </span>
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="info" variant="outline"
                         v-c-tooltip.hover="'Gán địa bàn'" square
                         size="sm"
                         @click="clickSetLocation(item)">
                  <i class="fa fa-cogs"/>
                </CButton>
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Cấu hình thời gian bật/tắt'" square
                         size="sm"
                         @click="clickConfigTimeOnOffDevice(item)">
                  <i class="fa fa-wrench"/>
                </CButton>
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Đồng bộ lại trình diễn'" square size="sm"
                         @click="asyncSlideShowDevice(item.id)">
                  <i class="fa fa-refresh"/>
                </CButton>
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Khởi động lại thiết bị'" square size="sm"
                         @click="restartDevice(item.id)">
                  <i class="fa fa-power-off"/>
                </CButton>
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật mô tả'" square size="sm"
                         @click="updateDescription(item.id, item.description)">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton color="danger" variant="outline" square size="sm" v-c-tooltip.hover="'Xóa'"
                         @click="setupSelectOneAction('delete_one', item.id, item.serialId)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Gán địa bàn cho thiết bị" :show.sync="isShowModalSetLocation" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSetLocation.locationLevelSelect.options"
                      :data="dataSetLocation.locationLevelSelect.data"
                      ref="dataSetLocationLocationLevelSelect"></BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSetLocation.locationCodeSelect.options"
                      :data="dataSetLocation.locationCodeSelect.data"
                      ref="dataSetLocationLocationCodeSelect"></BaseSelect>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalSetLocation = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitConfigLocation()"><i class="fa fa-check"></i> Gán
          địa bàn
        </button>
      </template>
    </CModal>

    <CModal title="Cập nhật mô tả thiết bị" :show.sync="isShowModalUpdateDescription" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseTextArea :options="dataDescription.descriptionInput.options"
                        :data="dataDescription.descriptionInput.data"
                        v-model="dataDescription.descriptionInput.data.model"/>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalUpdateDescription = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitUpdateDescription()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
    </CModal>

    <CModal title="Cập nhật thời gian bật/tắt màn hình" :show.sync="isShowModalTimeOnOff" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="6" xl="6" xs="6">
          <div class="form-group">
            <label for="timeOn">Thời gian bật <span class="required">*</span></label>
            <DatePicker class="mt-2"
                        id="timeOn"
                        mode="time"
                        v-model="dataTimeOnOff.timeOn"
                        :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                        is24hr>
            </DatePicker>
          </div>
        </CCol>
        <CCol sm="12" md="6" xl="6" xs="6">
          <div class="form-group">
            <label for="timeOff">Thời gian tắt <span class="required">*</span></label>
            <DatePicker class="mt-2"
                        id="timeOff"
                        mode="time"
                        v-model="dataTimeOnOff.timeOff"
                        :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                        is24hr>
            </DatePicker>
          </div>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalTimeOnOff = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitUpdateTimeOnOff()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
    </CModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import {USER_NAME} from '../../constant';
import {DatePicker} from "v-calendar";

export default {
  name: "DeviceList",
  components: {
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/devices/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.deviceSelectedId, userName: localStorage.getItem(USER_NAME)};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa thiết bị " + that.actionData.model.deviceSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("update_status", {
      url: "/devices/updateStatus",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.status == true ? "hủy duyệt" : "duyệt", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.deviceSelectedId, userName: localStorage.getItem(USER_NAME)
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: that.actionData.model.status == true ? "Hủy duyệt thiết bị thành công" : "Duyệt thiết bị thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      loading: {value: false},
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      isShowModalTimeOnOff: false,
      isShowModalUpdateDescription: false,
      isShowModalSetLocation: false,
      piAction: {},
      dataDescription: {
        id: null,
        descriptionInput: {
          options: {
            label: "Mô tả thiết bị",
            placeholder: "Mô tả thiết bị",
            maxlength: 2000,
            rows: 5
          },
          data: {
            name: "description",
            model: "",
            updateCallback: function () {
              that.submitUpdateDescription();
            }
          }
        }
      },
      dataSetLocation: {
        id: null,
        locationLevel: null,
        locationCode: null,
        locationLevelSelect: {
          options: {
            filter: false,
            label: 'Cập địa phương',
            'keyField': 'key',
            'valueField': 'value',
          },
          data: {
            name: "locationLevel",
            items: [
              {key: "0", value: "Cấp Tỉnh"},
              {key: "1", value: "Cấp Huyện"},
              {key: "2", value: "Cấp Xã"},
            ],
            model: null,
          },
        },
        locationCodeSelect: {
          options: {
            filter: true,
            label: "Địa phương",
            selectAllText: "Chọn địa phương",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: true
          },
          data: {
            name: "locationCode",
            items: [],
            model: null,
            source: {
              url: '/common/findAllLocationByLevel',
              dataSubmit: function () {
                return {
                  level: that.dataSetLocation.locationLevelSelect.data.model
                }
              },
              isJsonContentType: false,
              response: function (dataResponse) {
                that.dataSetLocation.locationCodeSelect.data.items = dataResponse.data;
                that.isShowModalSetLocation = true;
                setTimeout(() => {
                  that.dataSetLocation.locationCodeSelect.data.model = that.dataSetLocation.locationCode;
                }, 100)
              }
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSetLocation.locationCodeSelect.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Địa phương không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
      },
      dataTimeOnOff: {
        id: null,
        timeOn: null,
        timeOff: null
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          deviceSelectedId: null,
          deviceSelectedName: null,
          status: null,
        }
      },
      serialIdInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "serialId",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      descriptionInput: {
        options: {
          placeholder: "Mô tả",
          label: 'Mô tả'
        },
        data: {
          name: "description",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE')) ? false : true
        },
        data: {
          // name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          // name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      connectStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái kết nối',
        },
        data: {
          name: "connectStatus",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "1", value: "Kết nối"},
            {key: "0", value: "Mất kết nối"},
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái hoạt động',
        },
        data: {
          name: "activeStatus",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "status",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "1", value: "Đã duyệt"},
            {key: "0", value: "Chờ duyệt"},
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      mainTable: {
        options: {
          fields: [
            // {key: "index", label: "STT"},
            {key: "updateDate", label: "Cập nhật cuối", _style: "width:10%"},
            {key: "serialId", label: "Mã thiết bị"},
            {key: "activeStatus", label: "Trạng thái hoạt động"},
            {key: "connectStatus", label: "Trạng thái kết nối"},
            {key: "locationName", label: "Địa bàn"},
            {key: "description", label: "Mô tả", _style: "min-width:15%"},
            {key: "volume", label: "Âm lượng", _style: "width:8%;"},
            {key: "status", label: "Trạng thái", _style: "width:10%"},
            {key: "action", label: "Thao tác"},
          ],
          slots: ["index", "serialId", "volume", "activeStatus", "connectStatus", "updateDate", "status", "locationName", "action"],
          // lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false
        },
        dataSource: {
          url: "/devices/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter, isLoading) {
      this.$refs.mainTable.loadData(isUpdateFilter, isLoading);
    },
    setupSelectOneAction: function (actionTypeKey, deviceId, deviceName, status) {
      let actionData = this.actionData.model;
      actionData.deviceSelectedId = deviceId || null;
      actionData.deviceSelectedName = deviceName || null;
      actionData.status = status || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    clickConfigTimeOnOffDevice(item) {
      this.dataTimeOnOff.id = item.id;
      this.dataTimeOnOff.timeOn = new Date(this.$helper.convertStringTimeToDate(item.timeOn, "hh:mm:ss"));
      this.dataTimeOnOff.timeOff = new Date(this.$helper.convertStringTimeToDate(item.timeOff, "hh:mm:ss"));
      this.isShowModalTimeOnOff = true;
    },
    clickSetLocation(item) {
      let that = this;
      this.dataSetLocation.locationLevelSelect.data.model = null;
      this.dataSetLocation.id = item.id;
      this.dataSetLocation.locationCode = item.locationCode;
      this.dataSetLocation.locationCodeSelect.data.validator.isValid = true;
      setTimeout(() => {
        that.dataSetLocation.locationLevelSelect.data.model = item.locationLevel.toString() | "0";
      })
    },
    changeVolume(id, _volume) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/updateVolume",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id,
            volume: _volume,
            userName: localStorage.getItem(USER_NAME)
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thay đổi âm lượng thành công"
            });
            that.loadDataMainTable(false, false);
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    restartDevice(id) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/restart",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id,
            userName: localStorage.getItem(USER_NAME)
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Khởi động lại thiết bị thành công"
            });
            that.loadDataMainTable(false, false);
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    asyncSlideShowDevice(id) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/asyncSlideShow",
        isJsonContentType: false,
        ignoreDefaultData: true,
        dataSubmit: function () {
          return {
            deviceId: id
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Đồng bộ trình diễn thiết bị thành công"
            });
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    updateDescription(id, description) {
      this.isShowModalUpdateDescription = true;
      this.dataDescription.id = id;
      this.dataDescription.descriptionInput.data.model = description;
    },
    submitUpdateDescription() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/devices/updateDescription",
        dataSubmit: function () {
          return {
            id: that.dataDescription.id,
            description: that.dataDescription.descriptionInput.data.model
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cập nhật mô tả thiết bị thành công"});
            that.isShowModalUpdateDescription = false;
            that.loadDataMainTable(false, true);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitConfigLocation() {
      let isValid = this.dataSetLocation.locationCodeSelect.data.validator.valid();
      if (!isValid) {
        return;
      }
      let that = this;
      this.$helper.loadDataSource({
        url: "/devices/configLocation",
        dataSubmit: function () {
          return {
            id: that.dataSetLocation.id,
            locationCode: that.dataSetLocation.locationCodeSelect.data.model
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cập nhật địa bàn thiết bị thành công"});
            that.isShowModalSetLocation = false;
            that.loadDataMainTable(false, true);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitUpdateTimeOnOff() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/devices/configTimeOnOff",
        dataSubmit: function () {
          return {
            id: that.dataTimeOnOff.id,
            timeOn: that.$helper.formatDate(that.dataTimeOnOff.timeOn),
            timeOff: that.$helper.formatDate(that.dataTimeOnOff.timeOff),
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cấu hình thời gian bật/tắt thiết bị thành công"});
            that.isShowModalTimeOnOff = false;
            that.loadDataMainTable(false, true);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });

    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    'dataSetLocation.locationLevelSelect.data.model': function (value) {
      if (value) {
        this.$refs.dataSetLocationLocationCodeSelect.loadData();
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

.slider {
  width: 200px;
  max-width: 200px;
  padding: 0 !important;
}

.range-slider-rail, .range-slider-fill {
  height: 6px !important;
}

.range-slider-fill {
  background-color: #0b98ff;
}

.range-slider-knob {
  width: 15px !important;
  height: 15px !important;
}
</style>
